export default function ThankYou() {
  return (
      <main className="main">
        <div className="container">
        
              <div className="row justify-content-center">
                <div className="col-lg-12 ">
                   <div className="thank-you-div" >
                    <div>
                      <img src={`img/thank-you-v.jpeg`} alt="img-fluid" />
                        {/* <h1 className="thank-you-icon"> 🎉</h1> */}
                        <h1 style={{ fontSize: "40px", fontWeight: "700", marginBottom: "6px" }}>
                          Thank You!
                        </h1>
                        <p style={{ color: "#475569", fontSize: "14px", lineHeight: 1.0 ,marginBottom: "6px"}}>
                          Your form has been submitted successfully.
                        </p>
                        <p style={{ marginTop: "6px", fontSize: "12px", color: "#64748b" }}>
                          We appreciate your time — we'll review and get back to you soon.
                        </p>
                      </div></div>
                </div>
             
          </div>
        </div>
   
    </main>
  );
}
